import { useEffect, useState } from "react";

function Footer() {

    return (
        <>


            <footer className="rs-footer pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="rs-footer__bottom">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-lg-6">
                                        <div className="rs-footer__copyright-text text-center">
                                            <p>© 2026 RWFMS. All rights Reseved.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>


        </>
    );
}

export default Footer;
